import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';
import { FieldOkObjektItem } from '../models/field-ok-objekt-item.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-objekt-list-view',
  imports: [],
  templateUrl: './objekt.list-view.html',
  styleUrls: ['./objekt.list-view.css'],
})
export class ObjektListView implements FieldOkItemComponent<FieldOkObjektItem> {
  readonly item = input.required<FieldOkObjektItem>();
}
